import styled from "styled-components";

export const DatetimeScatterChart = styled.div`
  height: 150%;
  width: 100%;
`
